import { useEffect, useState } from 'react';
import { ANG_APIS } from '../../api.constants';
import { useParams } from 'react-router-dom';
import CommonAddContact from '../common/CommonAddContact';
import APIService from '../../../Services/APIService';

export default function BasicDetailsEducationInstitute() {
  const { id } = useParams();
  const [vendors, setVendors] = useState();
  const [details, setDetails] = useState();
  const [formData, setFormData] = useState();
  const initialContactForm = {
    contact_type: '',
    country_code: '',
    email: '',
    landline: null,
    mobile: null,
    name: '',
    object_id: '',
    salutation: '',
    std_code: '',
  };

  const getOrganizations = async () => {
    let res = await APIService.get(ANG_APIS.GET_ORGANIZATIONS);
    if (res.status == 200) setVendors(res.data);
  };

  const getDetails = async () => {
    let res = await APIService.get(`${ANG_APIS.GET_LIST_GENERIC}${id}/?supplier_type_code=EI`);
    if (res.status == 200) {
      setDetails(res.data);
      setFormData(res.data);
    };
  };

  useEffect(() => {
    getOrganizations();
    getDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;
    setFormData(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let res = await APIService.put(`${ANG_APIS.GET_LIST_GENERIC}${id}`, formData);
    if (res) alert('Done');
  };

  const handleAddContact = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contactData: [...prevFormData.contactData, initialContactForm],
    }));
  };

  return (
    <>
      <div className="tabContentBox">
        <div className="top">
          <label>Representative:</label>
          <select
            className="form-control"
            ng-model="representativeField.name"
            ng-change="setVendor()"
          >
            <option value="" disabled>
              Select Representative/Principal Vendor
            </option>
            {vendors &&
              vendors.map((vendor, key) => {
                return (
                  <option key={key} value={vendor.name} ng-repeat="vendor in vendorData">
                    {vendor.name}
                  </option>
                );
              })}
          </select>
        </div>
        <form role="form" name="hording_form" onSubmit={handleSubmit}>
          <div className="contentBox">
            <div className="item">
              <label for="supplier_id">Education Institute ID</label>
              <input
                type="text"
                className="field"
                id="supplier_id"
                value={details?.supplier_id}
                disabled
                readonly
              />
            </div>
            <div className="item">
              <label for="supplier_name">
                Name<span>*</span>
              </label>
              <input
                type="text"
                disabled
                className="field"
                placeholder="Name"
                id="supplier_id"
                value={details?.name}
                required
              />
            </div>
            <div className="item">
              <label for="address1">
                Address1<span>*</span>
              </label>
              <input
                type="text"
                className="field"
                placeholder="Address1"
                id="address1"
                value={details?.master_data.address_supplier.address1}
                required
              />
            </div>
            <div className="item">
              <label for="address2">Address2</label>
              <input
                type="text"
                className="field"
                placeholder="Address2"
                id="address2"
                value={details?.master_data.address_supplier.address2}
              />
            </div>
            <div className="item">
              <label for="landmark_bus_shelter">Nearest LandMark</label>
              <input
                type="text"
                name="nearest_landmark"
                placeholder="Nearest LandMark"
                className="field"
                id="landmark_bus_shelter"
                value={details?.master_data.landmark}
                ng-pattern="/^[a-z0-9A-Z\s]*$/"
              />
              <div ng-show="hording_form.nearest_landmark.$error.pattern" className="error">
                Landmark Name Invalid
              </div>
            </div>
            <div className="item">
              <label for="city">City</label>
              <input
                type="text"
                className="field"
                id="city"
                placeholder="City"
                value={details?.master_data.address_supplier.city}
                disabled
                readonly
              />
            </div>
            <div className="item">
              <label for="state">State</label>
              <input
                type="text"
                className="field"
                id="state"
                placeholder="State"
                value={details?.master_data.address_supplier.state}
                disabled
                readonly
              />
            </div>
            <div className="item">
              <label for="area">Area</label>
              <input
                type="text"
                className="field"
                id="area"
                placeholder="Area"
                value={details?.master_data.address_supplier.area}
                disabled
                readonly
              />
            </div>
            <div className="item">
              <label for="locality">Sub Area</label>
              <input
                type="text"
                className="field"
                placeholder="Sub Area"
                id="subarea"
                value={details?.master_data.address_supplier.subarea}
                disabled
                readonly
              />
            </div>
            <div className="item">
              <label for="zipcode">Zip Code</label>
              <input
                type="number"
                onkeydown="javascript: return event.keyCode == 69 ? false : true"
                name="zip_code"
                placeholder="Zip Code"
                className="field"
                id="zipcode"
                value={details?.master_data.address_supplier.zipcode}
                ng-pattern="/^[0-9]{6}$/"
              />
              <div ng-show="hording_form.zip_code.$error.pattern" className="error">
                Please enter 6 digit positive numbers only
              </div>
            </div>
            <div className="item">
              <label for="latitude">Latitude</label>
              <input
                type="number"
                onkeydown="javascript: return event.keyCode == 69 ? false : true"
                step="any"
                className="field"
                id="latitude"
                value={details?.master_data.address_supplier.latitude}
              />
            </div>
            <div className="item">
              <label for="longitude">Longitude</label>
              <input
                type="number"
                onkeydown="javascript: return event.keyCode == 69 ? false : true"
                step="any"
                className="field"
                id="longitude"
                value={details?.master_data.address_supplier.longitude}
              />
            </div>
            <div className="item">
              <label>Education Institute Type</label>
              <select className="field" value={details?.inst_type} ng-change="instSelect()">
                <option value="" disabled>
                  Select Education Institute Type{' '}
                </option>
                {/* <option ng-repeat="instType in educationInstType" value="{{instType}}">{{instType}}</option> */}
              </select>
            </div>
            <div className="item" ng-show="model.inst_type == 'Others'">
              <label for="longitude">Other Institute type</label>
              <input
                type="text"
                step="any"
                className="field"
                id="longitude"
                value={details?.inst_other_type}
              />
            </div>
            <div className="item">
              <label>Sub Type</label>
              <select className="field" value={details?.inst_sub_type}>
                <option value="" disabled>
                  Select Sub Type{' '}
                </option>
                {/* <option ng-repeat="instSubType in educationInstSubType" value="{{instSubType}}">{{instSubType}}</option> */}
              </select>
            </div>
            <div className="item" ng-show="model.inst_sub_type == 'Others'">
              <label for="longitude">Other Institute sub type</label>
              <input
                type="text"
                step="any"
                className="field"
                id="sub"
                value={details?.inst_sub_other_type}
              />
            </div>
            <div className="item">
              <label>Education Board</label>
              <select className="field" value={details?.educationBoard}>
                <option value="" disabled>
                  Select Education Board
                </option>
                {/* <option ng-repeat="edb in educationBoard" value="{{edb}}">{{edb}}</option> */}
              </select>
            </div>
            <div className="item" ng-show="model.educationBoard == 'Others'">
              <label for="longitude">Other Education Board</label>
              <input
                type="text"
                step="any"
                className="field"
                id="sub"
                value={details?.educationBoard_other}
              />
            </div>
            <div className="item">
              <label for="comments">Comment</label>
              <input
                type="text"
                placeholder="Comment"
                className="field"
                id="comments"
                value={details?.comments}
              />
            </div>
            <div className="item">
              <label for="eyeball_count ">Total No. of Students</label>
              <input
                type="text"
                placeholder="Total No. of Students"
                className="field"
                id="eyeball_count"
                value={details?.master_data.unit_primary_count}
              />
            </div>
            <div className="item">
              <label for="traffic_count ">Total No. of Teachers & Employees</label>
              <input
                type="text"
                placeholder="Total No. of Teachers & Employees"
                className="field"
                id="traffic_count"
                value={details?.master_data.unit_secondary_count}
              />
            </div>
            <div className="item">
              <label for="comments">Feedback</label>
              <textarea
                rows="4"
                cols="50"
                className="field"
                id="feedback_id"
                name="feedback"
                placeholder="How many buildings, classes, sections, etc."
                value={details?.master_data.feedback}
              ></textarea>
            </div>
            <h2 className="heading">Payment Details</h2>
            <div className="item">
              <label>Name of Education Institute</label>
              <br />
              <input
                type="text"
                className="form-control"
                ng-model="ownership_details.bank_account_name"
                placeholder="Name of education institute"
              />
            </div>
            <div className="item">
              <label>Bank Name</label>
              <br />
              <input
                type="text"
                className="form-control"
                ng-model="ownership_details.bank_name"
                placeholder="Bank Name"
              />
            </div>
            <div className="item">
              <label>IFSC Code</label>
              <br />
              <input
                type="text"
                className="form-control"
                ng-model="ownership_details.ifsc_code"
                placeholder="IFSC Code"
              />
            </div>
            <div className="item">
              <label>Account number</label>
              <br />
              <input
                type="text"
                className="form-control"
                ng-model="ownership_details.account_number"
                placeholder="Account number"
              />
            </div>
            <div className="item">
              <label for="terms_condition">Payment Terms & Condition</label>
              <textarea
                rows="4"
                cols="50"
                className="field"
                id="terms_condition_id"
                name="terms_condition"
                placeholder="Payment Terms & Condition"
                ng-model="ownership_details.payment_terms_condition"
              ></textarea>
            </div>
          </div>
          <h2 className="heading">Contact Details</h2>
          <CommonAddContact formData={formData} setFormData={setFormData} />
          <input
            onClick={handleAddContact}
            type="button"
            className="smallBtn"
            value="Add"
            ng-click="addNewContact()"
          />
          <br />
          <br />
          <div className="bottomButtonBox">
            <button type="submit" className="smallBtn">
              Update Education Institute
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
